import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Clock, CheckCircle, XCircle, Users } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import logo from "../../assets/logo.png";

const navItems = [
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, requireAdmin: false },
  { path: '/pending', label: 'Pending', icon: Clock, requireAdmin: false },
  { path: '/resolved', label: 'Approved', icon: CheckCircle, requireAdmin: false },
  { path: '/approved-overridden', label: 'Approved & Overridden', icon: CheckCircle, requireAdmin: false },
  { path: '/rejected', label: 'Rejected', icon: XCircle, requireAdmin: false },
  {
    label: 'User Management',
    icon: Users,
    requireAdmin: true,
    children: [
      { path: '/users', label: 'List Users' },
      // { path: '/unauthorized-users', label: 'Unauthorized Users' },
    ],
  },
];

export const Sidebar = () => {
  const { isAdmin } = useAuth();
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState('User Management');

  return (
    <aside className="fixed left-0 top-0 w-64 h-screen bg-gradient-to-r from-[#472f92] to-[#6a4bc5]">
	
	<div className="flex flex-col h-full">
	<div className="flex items-center justify-center px-1 py-1 border-slate-800">
          <img
            src={logo}
            alt="Fayda Logo"
            className="h-12 sm:h-16 object-contain"
          />
        </div>
        <div className="flex items-center justify-center gap-3 px-1 py-1 border-b border-slate-800">
          <div>
            <h1 className="text-xl font-bold text-white">KYC Portal</h1>
            <p className="text-xs text-slate-400">Verification System</p>
          </div>
        </div>
      <nav className="px-4 py-6 space-y-1">
        {navItems.map((item) => {
          if (item.requireAdmin && !isAdmin) return null;
          const Icon = item.icon;

          // 🔹 With children (submenu)
          if (item.children) {
            const isOpen = openMenu === item.label;

            return (
              <div key={item.label}>
                <button
                  onClick={() => setOpenMenu(isOpen ? null : item.label)}
                  className="flex w-full items-center justify-between px-4 py-3 text-slate-200 hover:bg-slate-800 rounded-lg"
                >
                  <div className="flex items-center gap-3">
                    <Icon className="w-5 h-5" />
                    {item.label}
                  </div>
                  <ChevronDown
                    className={`w-4 h-4 transition ${isOpen ? 'rotate-180' : ''}`}
                  />
                </button>

                {isOpen && (
                  <div className="ml-6 mt-1 space-y-1">
                    {item.children.map((child) => (
                      <NavLink
                        key={child.path}
                        to={child.path}
                        className={({ isActive }) =>
                          `block px-4 py-2 rounded-lg text-sm ${
                            isActive
                              ? 'bg-[#e4ac24] text-white'
                              : 'text-slate-300 hover:bg-slate-800'
                          }`
                        }
                      >
                        {child.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>
            );
          }

          // 🔹 Normal item
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-lg ${
                  isActive
                    ? 'bg-[#e4ac24] text-white'
                    : 'text-slate-300 hover:bg-slate-800'
                }`
              }
            >
              <Icon className="w-5 h-5" />
              {item.label}
            </NavLink>
          );
        })}
      </nav>
	  </div>
    </aside>
  );
};